import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { WEIGHT_SECTIONS, SCORING_CRITERIA_SECTIONS } from '../constants/driverScoringConstants';
import { ScoringGrid } from 'packages/novous_web/src/common/components';
import CustomText from 'packages/novous_web/src/common/components/CustomText';

interface DriverScoringModalProps {
  open: boolean;
  onClose: () => void;
}

const DriverScoringModal: React.FC<DriverScoringModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, maxHeight: '90vh' },
      }}
    >
      <DialogTitle>
        <CustomText variant="h6" fontWeight={600}>
          Driver Score Logic
        </CustomText>
        <CustomText variant="subHeading" sx={{ mt: 0.5 }}>
          Driver Score is calculated based on driving behavior. Each category below contributes points
          depending on performance
        </CustomText>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <CustomText variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Driver Score Breakdown (by Alert)
            </CustomText>
            <ScoringGrid sections={SCORING_CRITERIA_SECTIONS} />
          </Box>

          <Box>
            <CustomText variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Scoring Factors & Weightage
            </CustomText>
            <ScoringGrid sections={WEIGHT_SECTIONS} />
          </Box>

          <Box>
            <CustomText variant="h6" fontWeight={600} sx={{ mb: 1 }}>
              Event Normalization Formula
            </CustomText>
            <CustomText variant="caption" sx={{ color: '#767676' }}>
              (Event Count ÷ Distance Travelled) × 1000
            </CustomText>
            <Box sx={{ mt: 1, p: 2, borderRadius: 1, backgroundColor: '#F7F7FF' }}>
              <CustomText variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                Example (Drowsy):
              </CustomText>
              <ul className="list-disc ml-5">
                <li>
                  <CustomText variant="body2">Events: 12</CustomText>
                </li>
                <li>
                  <CustomText variant="body2">Distance Travelled: 200</CustomText>
                </li>
                <li>
                  <CustomText variant="body2">Calculation: (12 ÷ 200) × 1000 = 60</CustomText>
                </li>
                <li>
                  <CustomText variant="body2">As 60 &gt; 10, therefore</CustomText>
                </li>
              </ul>
              <CustomText variant="body2" fontWeight={700} sx={{ mt: 0.5 }}>
                Final Score: 0
              </CustomText>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DriverScoringModal;
